import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateOrder = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.5 0C5.2 0 0 5.2 0 11.5C0 17.8 5.2 23 11.5 23C17.8 23 23 17.8 23 11.5C23 5.2 17.8 0 11.5 0ZM11.5 22C5.7 22 1 17.3 1 11.5C1 5.7 5.7 1 11.5 1C17.3 1 22 5.7 22 11.5C22 17.3 17.3 22 11.5 22Z",
		fill: "#FF6200"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.5 11H12V6.5C12 6.2 11.8 6 11.5 6C11.2 6 11 6.2 11 6.5V11H6.5C6.2 11 6 11.2 6 11.5C6 11.8 6.2 12 6.5 12H11V16.5C11 16.8 11.2 17 11.5 17C11.8 17 12 16.8 12 16.5V12H16.5C16.8 12 17 11.8 17 11.5C17 11.2 16.8 11 16.5 11Z",
		fill: "#FF6200"
	})]
});
export default SvgCreateOrder;
